/**
 * Sync the "Request a Quote" button href with the currently selected variant.
 * The button is rendered via custom Liquid with a static variant_id from
 * product.selected_or_first_available_variant.id — this script updates it
 * dynamically when the user selects a different variant on the PDP.
 */
(function () {
  'use strict';

  var button = document.getElementById('OrderRequestButton');
  var btoButton = document.getElementById('psw-bto-cta');
  if (!button && !btoButton) return;

  // Listen for Shopify's variant change event (dispatched by the theme's variant selects)
  document.addEventListener('change', function (e) {
    var target = e.target;
    // Detect variant select/radio changes within the product form
    if (!target.closest || !target.closest('variant-selects, variant-radios, [data-section]')) return;

    // Wait a tick for the theme JS to update the URL with the new variant param
    setTimeout(syncButton, 50);
  });

  // Also listen for popstate/URL changes (some themes update the URL on variant change)
  window.addEventListener('popstate', function () { setTimeout(syncButton, 50); });

  // Watch for the variant parameter in the page URL
  var lastVariant = null;
  function syncButton() {
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId || variantId === lastVariant) return;
    lastVariant = variantId;

    // Update the main Inquire button href
    if (button) {
      var url = new URL(button.href, window.location.origin);
      url.searchParams.set('variant_id', variantId);
      button.href = url.toString();
    }

    // Update the Built to Order button href
    if (btoButton) {
      var btoUrl = new URL(btoButton.href, window.location.origin);
      btoUrl.searchParams.set('variant_id', variantId);
      btoButton.href = btoUrl.toString();
    }
  }

  // Also observe the URL for changes via history.replaceState (used by many themes)
  var origReplaceState = history.replaceState;
  history.replaceState = function () {
    origReplaceState.apply(this, arguments);
    setTimeout(syncButton, 10);
  };

  var origPushState = history.pushState;
  history.pushState = function () {
    origPushState.apply(this, arguments);
    setTimeout(syncButton, 10);
  };

  // Run once on load in case the page already has a variant param
  syncButton();
})();
